'use client';
import React, { useState } from 'react';
import style from './style.module.scss';
import { MediaList, NewsSkeleton } from '@/components';
import { Pagination } from '@/components/shared';
import { VideosList } from '../videos-list/videos-list';
import { VideosSkeleton } from './widgets/videos-skeleton';
import Skeleton from 'react-loading-skeleton';
export const VideosMedia = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchResult, setSearchResult] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  const handleLoading = (e: boolean) => {
    setLoading(e);
  };

  const handleSearch = (value: string) => {
    setSearchResult(value);
  };

  const handleData = (e: any) => {
    setData(e);
  };
  return (
    <div className={style.media}>
      <div className={style.list}>
        {loading ? (
            <Skeleton width={400} height={250} count={1} />
        ) : data?.length > 0 ? (
          <VideosList arr={data} />
        ) : (
          <div className={style.notFound}>
            <h4>Ничего не найдено</h4>
          </div>
        )}
      </div>
      <div className={style.pagination}>
        <Pagination
          altSearch="?pagination[page]=1&pagination[pageSize]=5&populate=*&sort[createdAt]=desc"
          isSearch={true}
          isPagination
          setData={handleData}
          loader={handleLoading}
          link="media-videorolikis"
          searchValue={searchResult}
          setSearchValue={setSearchValue}
        />
      </div>
    </div>
  );
};
